import { z } from "zod";
export const SystemFacet = z.enum([
    "heating_cooling",
    "underfloor_heating",
    "whole_home_ui",
    "metering",
    "bms_integration",
    "network_infra",
    "commissioning"
]);
export const SystemFacetValues = SystemFacet.options;
export const RiskNatureFacet = z.enum([
    "capacity",
    "catalog_gap",
    "conflict",
    "scope_ambiguity",
    "cost_note",
    "clarification",
    "other"
]);
export const RiskNatureFacetValues = RiskNatureFacet.options;
export const RiskActionOwnerFacet = z.enum([
    "user",
    "client",
    "installer",
    "estimator",
    "engine"
]);
export const RiskActionOwnerFacetValues = RiskActionOwnerFacet.options;
export const ScopeWorkTypeFacet = z.enum([
    "supply",
    "install",
    "configuration",
    "integration",
    "commissioning",
    "documentation"
]);
export const ScopeWorkTypeFacetValues = ScopeWorkTypeFacet.options;
export const ScopeCommercialFacet = z.enum([
    "priced",
    "install_note",
    "allowance",
    "ve_candidate"
]);
export const ScopeCommercialFacetValues = ScopeCommercialFacet.options;
export const RequirementTypeFacet = z.enum([
    "functional",
    "quantity",
    "interface",
    "performance",
    "commissioning",
    "commercial"
]);
export const RequirementTypeFacetValues = RequirementTypeFacet.options;
export const RequirementSourceKindFacet = z.enum([
    "narrative",
    "schedule",
    "requirements_doc",
    "inferred"
]);
export const RequirementSourceKindFacetValues = RequirementSourceKindFacet.options;
export const RequirementTagsObjectSchema = z
    .object({
    system: SystemFacet.optional(),
    systemSecondary: SystemFacet.nullable().optional(),
    requirementType: RequirementTypeFacet.optional(),
    sourceKind: RequirementSourceKindFacet.optional()
})
    .strict();
export const RequirementTagsSchema = RequirementTagsObjectSchema.optional();
export const RiskTagsObjectSchema = z
    .object({
    system: SystemFacet.optional(),
    systemSecondary: SystemFacet.nullable().optional(),
    nature: RiskNatureFacet.optional(),
    actionOwner: RiskActionOwnerFacet.optional()
})
    .strict();
export const RiskTagsSchema = RiskTagsObjectSchema.optional();
export const ScopeTagsObjectSchema = z
    .object({
    system: SystemFacet.optional(),
    systemSecondary: SystemFacet.nullable().optional(),
    workType: ScopeWorkTypeFacet.optional(),
    commercial: ScopeCommercialFacet.optional()
})
    .strict();
export const ScopeTagsSchema = ScopeTagsObjectSchema.optional();
//# sourceMappingURL=tags.js.map